import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-resetpasswordpopup',
  templateUrl: './resetpasswordpopup.component.html',
  styleUrls: ['./resetpasswordpopup.component.css']
})
export class ResetpasswordpopupComponent implements OnInit {
Pass:string
usertype:string=localStorage.getItem('usertype')
errorPassword:boolean = false
passwordValidation:boolean=false
showEye:boolean=true

  constructor(private auth:AuthService,private toaster:ToastrService,private router:Router) { }

  ngOnInit() {
  //  document.getElementById('passwordResetbutton').click()
  }
  setPass(event:NgForm){
    let pass = this.Pass
let re = /[a-zA-Z]/
let num= /[1-9]/
let special  = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

if (re.test(pass) && num.test(pass) && special.test(pass)){
  this.passwordValidation = false
}
else{
  this.passwordValidation = true
}
    if(event.valid && !this.passwordValidation){
      this.auth.setPasword(this.Pass).subscribe(res=>{
      
       
        document.getElementById('passwordResetbutton').click()
        this.toaster.success('Password Set...', 'Success',{
          timeOut: 2000
       });
      let  usertype_local = localStorage.getItem('usertype')
       if(usertype_local=='User'){
        localStorage.setItem('logindata',JSON.stringify(res["data"]))
        $(document.body).removeClass("modal-open");
        $(".modal-backdrop").remove();
      
       // document.getElementById('timingModalIdClick').click()
       }
       else{
       document.getElementById('timingModalIdClick').click()
       }
     
       
      //  this.router.navigate([`/${this.usertype}/dashboard`])
      },error=>{
       
        this.toaster.error('There was some Error setting your Password...', 'Error',{
          timeOut: 2000
        });
        this.errorPassword = true
      })
    }
    }

}
